module.exports = __webpack_public_path__ + "img/Bitmap@2x 32(1).bfb85ac3.png";